var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkup24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9836 4.9836C5.41638 4.55082 6.00335 4.30769 6.61538 4.30769H14L16 2H6.61538C5.39131 2 4.21737 2.48626 3.35181 3.35181C2.48626 4.21737 2 5.39131 2 6.61538V17.3846C2 18.6087 2.48626 19.7826 3.35181 20.6482C4.21737 21.5137 5.39131 22 6.61538 22H17.3846C18.6087 22 19.7826 21.5137 20.6482 20.6482C21.5137 19.7826 22 18.6087 22 17.3846V7.5L19.6923 10V17.3846C19.6923 17.9967 19.4492 18.5836 19.0164 19.0164C18.5836 19.4492 17.9967 19.6923 17.3846 19.6923H6.61538C6.00335 19.6923 5.41638 19.4492 4.9836 19.0164C4.55082 18.5836 4.30769 17.9967 4.30769 17.3846V6.61538C4.30769 6.00335 4.55082 5.41638 4.9836 4.9836Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7419 5.56639C22.086 5.22232 22.086 4.64888 21.7419 4.32245L19.6775 2.25805C19.3511 1.91398 18.7777 1.91398 18.4336 2.25805L16.7045 3.98721L20.0128 7.29554M19.1306 8.17777L15.8222 4.86943L7 13.6917V17H10.3083L19.1306 8.17777Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkup24);
export default __webpack_public_path__ + "static/media/Markup24.02a0423d872471a7d1482b1ca1812803.svg";
export { ForwardRef as ReactComponent };